var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("table", { staticClass: "tbl_comparison" }, [
      _c("tbody", [
        _c("tr", [
          _c("th"),
          _vm._v(" "),
          _c("th", [_vm._v("価格")]),
          _vm._v(" "),
          _c("th", [_vm._v("サイズ種類")]),
          _vm._v(" "),
          _c("th", [_vm._v("色柄種類")]),
          _vm._v(" "),
          _c("th", [_vm._v("納期")]),
          _vm._v(" "),
          _c("th", [_vm._v("ピッタリ設置")])
        ]),
        _vm._v(" "),
        _c("tr", { staticClass: "tr_pickup" }, [
          _c("td", [_vm._v("mm/style")]),
          _vm._v(" "),
          _c("td", [
            _c("span", [_vm._v("○")]),
            _c("br"),
            _vm._v("低価格から高価格まで品揃え")
          ]),
          _vm._v(" "),
          _c("td", [
            _c("span", [_vm._v("◎")]),
            _c("br"),
            _vm._v("1mm単位でオーダー可能")
          ]),
          _vm._v(" "),
          _c("td", [
            _c("span", [_vm._v("○")]),
            _c("br"),
            _vm._v("豊富な色柄から選択可能")
          ]),
          _vm._v(" "),
          _c("td", [
            _c("span", [_vm._v("○")]),
            _c("br"),
            _vm._v("約10営業日から対応")
          ]),
          _vm._v(" "),
          _c("td", [
            _c("span", [_vm._v("◎")]),
            _c("br"),
            _vm._v("ピッタリオーダーが可能")
          ])
        ]),
        _vm._v(" "),
        _c("tr", [
          _c("td", [_vm._v("既製品"), _c("br"), _vm._v("量産品")]),
          _vm._v(" "),
          _c("td", [_c("span", [_vm._v("◎")])]),
          _vm._v(" "),
          _c("td", [_c("span", [_vm._v("×")])]),
          _vm._v(" "),
          _c("td", [_c("span", [_vm._v("×")])]),
          _vm._v(" "),
          _c("td", [_c("span", [_vm._v("◎")])]),
          _vm._v(" "),
          _c("td", [_c("span", [_vm._v("×")])])
        ]),
        _vm._v(" "),
        _c("tr", [
          _c("td", [_vm._v("システム家具")]),
          _vm._v(" "),
          _c("td", [_c("span", [_vm._v("△")])]),
          _vm._v(" "),
          _c("td", [_c("span", [_vm._v("○")])]),
          _vm._v(" "),
          _c("td", [_c("span", [_vm._v("○")])]),
          _vm._v(" "),
          _c("td", [_c("span", [_vm._v("○")])]),
          _vm._v(" "),
          _c("td", [_c("span", [_vm._v("◎")])])
        ]),
        _vm._v(" "),
        _c("tr", [
          _c("td", [_vm._v("オーダー家具")]),
          _vm._v(" "),
          _c("td", [_c("span", [_vm._v("×")])]),
          _vm._v(" "),
          _c("td", [_c("span", [_vm._v("◎")])]),
          _vm._v(" "),
          _c("td", [_c("span", [_vm._v("◎")])]),
          _vm._v(" "),
          _c("td", [_c("span", [_vm._v("×")])]),
          _vm._v(" "),
          _c("td", [_c("span", [_vm._v("◎")])])
        ])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-beda55e0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-beda55e0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/main/js/hakotan/components/top/DcSelectReasonTable.vue
// module id = null
// module chunks = 